<template>
  <div>
    <EmptyView v-if="isShowEmptyView" tabRequesting=tabRequesting style="margin-top: 150px;" v-on:reload-event="getMyListVacation(true)"/>
    <v-card id="cardTabMyList" outlined>
      <div v-if="isShowErrorView" v-on:click="getMyListVacation(true)" class="mx-auto" style="margin-top:100px; width:350px; height:400px;" >
        <ErrorView class="mx-auto" />
      </div>
      <div v-for="(vacationIds, date) in dividerDateTitles" :key="date">
        <DividerLine :groupTile="date" />
        <VacationItemRow v-for="vacationId in vacationIds" :key="vacationId" :vacationDate="date" :vacationInfo="getVacationById(vacationId)"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue';
import VacationItemRow from "@/components/commonui/topView/VacationItemRow";
import EmptyView from "../commonui/topView/EmptyView";
import ErrorView from "../commonui/topView/ErrorView";
import DividerLine from "../commonui/topView/DividerLine";
import { ListEvents, DefaultValues, TabNames, VacationStatus, groupedDatesbyId, resizeMixin, getUserRole, isApprover,} from "@/utilities/CommonUtilities";
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import moment from 'moment';

export default {
  mixins: [resizeMixin],
  components: {VacationItemRow, EmptyView, ErrorView, DividerLine},
  data() {
    return {
      pageSize: DefaultValues.page_size,
      currentPageNumber: 1,
      pageInfo: {},
      listVacations:[],
      isShowEmptyView: false,
      isShowErrorView: false,
      isLoading: false,
      isDestroyed: false,
      keyIndex:0,
      dividerDateTitles: [],
      tabRequesting: true,
      fromDate: moment().subtract(1, 'years').format('YYYY-MM-DD'),
      toDate: moment().add(2, 'years').format('YYYY-MM-DD'),
    }
  },
  computed: {
    ...mapState(["userInfo", "token", "listUser"]),
    ...mapGetters({
      getTabInfo: "homeData/getTabInfo"
    }),
    ...mapGetters({
      filter: "homeData/getFilterInfo",
    }),
    ...mapState({
      tabSelecting: state => state.homeData.currentTab,
      selectedTab: (state) => state.homeData.selectedTab,
    }),
  },
  methods: {
    ...mapMutations({
        saveTabInfo: "homeData/setTabInfo",
    }),
    ...mapActions({
        resetAllTabInfo: "homeData/resetAllTabInfo"
    }),
    getVacationById(id) {
      return this.listVacations.find(vacation => vacation.id === id);
    },
    //Change date conditions.
    updateDividerDateTitles() {
      if (this.filter.firstDayOfMonth && this.filter.lastDayOfMonth) {
        let startDate = new Date(this.fromDate);
        let endDate = new Date(this.toDate);
        this.dividerDateTitles = groupedDatesbyId(this.listVacations, startDate, endDate, this.listUser);
      }
    },
    isShowIconInProgress() {
      let userRole = getUserRole(this.userInfo.serviceInformation);
      return isApprover(userRole);
    },
    refreshDataFromDatePicker(){
      if(this.selectedTab === TabNames.Requesting)
        this.getMyListVacation(true);
    },
    async getMyListVacation(isShowIndicator) {
      if(this.isLoading || this.listUser == null || this.listUser.length == 0) {
        return;
      }

      this.isLoading = true;
      if(isShowIndicator) this.notifyBus.$emit(ListEvents.showLoadingIndicator);
      try{
        let params = {
          'token': this.token, 
          'limit': DefaultValues.page_size,
          'offset': (this.currentPageNumber - 1) * DefaultValues.page_size,
          'order_from':'asc'
        };
        if (this.filter != null) {
            params['from_date'] = `${this.fromDate} 00:00:00`;
            params['to_date'] = `${this.toDate} 23:59:59`;
            params['order_from'] = 'desc';
        }
        
        let response = await this.dataSource.getData( this.dataSource.listVacations, params);
        let vacationsInPage = response.data['vacations'];
        let totalPage = response.data['totalPage'];
        this.pageInfo.pageItems = vacationsInPage;
        this.pageInfo.totalPage = totalPage;
        this.pageInfo.currentPage = this.currentPageNumber;

        if (!this.isShowIconInProgress()) {
          this.listVacations = vacationsInPage.filter(vacation =>
            vacation.user_id === this.userInfo.userID &&
            vacation.status === VacationStatus.InProgress
          );
          this.listCalendars = vacationsInPage.filter(vacation => 
          (vacation.status === VacationStatus.Approved) || 
          (vacation.status === VacationStatus.InProgress && vacation.user_id === this.userInfo.userID)
        );
        } else {
          this.listCalendars = vacationsInPage
          this.listVacations = vacationsInPage.filter(item =>item.status === VacationStatus.InProgress);
        }
        this.keyIndex += 1;
        if(this.listVacations.length == 0) {
          this.isShowEmptyView = true;  
        } else {
          this.isShowEmptyView = false;
        }

        let thisInfo = {};
        Object.assign(thisInfo, this.pageInfo);
        this.saveTabInfo({ tabInfo: thisInfo, tabName: TabNames.Requesting});

        if(this.isDestroyed) return;
        this.notifyBus.$emit(ListEvents.setStatusMonth, this.listCalendars)
        this.notifyBus.$emit(ListEvents.setPagination, { currentPageNumber: this.currentPageNumber, totalPage: totalPage});

        //hide error view
        this.isShowErrorView = false;
      } catch(ex) {
        //error at the first time
        if(this.pageInfo.totalPage == null) {
          this.isShowErrorView = true;
          return;
        }

        this.currentPageNumber = this.pageInfo.currentPage;
        this.notifyBus.$emit(ListEvents.setPagination, { currentPageNumber: this.pageInfo.currentPage, totalPage: this.pageInfo.totalPage});
        if(isShowIndicator) {
           this.notifyBus.$emit(ListEvents.showOKDialog, this.$i18n.t('common_unknown_error'));
        }
        return;
      } finally {
        if(isShowIndicator) this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
        this.isLoading = false;
      }
    }
  },
  watch: {
    listVacations: {
    handler() {
    this.updateDividerDateTitles();
    },
    deep: true
    }
  },
  mounted() {
    this.updateDividerDateTitles();
    this.notifyBus.$on(ListEvents.vacationList, this.refreshDataFromDatePicker);
  },
  created() {
    this.updateDividerDateTitles();
    if (this.homeViewBus instanceof Vue) {
      this.homeViewBus.$on(ListEvents.loadDataCompleted, (tabName) => {
        if(tabName == null) {
          this.getMyListVacation(true);
        }
      });
    }  
    this.notifyBus.$on(ListEvents.paginationChanged, (newCurrentPage) => {
      if(this.isLoading || newCurrentPage == this.currentPageNumber || this.isDestroyed) return;

      this.currentPageNumber = newCurrentPage;
      this.getMyListVacation(true);
    });

    this.notifyBus.$on(ListEvents.reloadAllTabs,(reloadAll) => {
      if(this.isDestroyed) return;
      if(reloadAll) {
        this.resetAllTabInfo();

        this.pageInfo = this.getTabInfo(TabNames.Requesting);
        this.currentPageNumber = this.pageInfo.currentPage;
        if(this.pageInfo.totalPage != null) {
          this.notifyBus.$emit(ListEvents.setPagination, { currentPageNumber: this.pageInfo.currentPage, totalPage: this.pageInfo.totalPage});
        }
      }

      this.getMyListVacation(true);
    });
    this.getMyListVacation( this.pageInfo.totalPage == null);
  },
  beforeDestroy: function() {
    this.isDestroyed = true;
    this.notifyBus.$off(ListEvents.vacationList, this.refreshDataFromDatePicker);
  },
  inject: ["dataSource", "notifyBus", "homeViewBus"],
};
</script>

<style scoped>
#cardTabMyList{
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius:0px;
}
</style>
